export function getMobileOS() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        return '--Android';
    }

    // iOS detection (iPad, iPhone, iPod)
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return '--iOS';
    }

    return 'Unknown';
}

export function toastPopup(
    message: string,
    type: 'success' | 'error' | 'info' | 'warning' = 'info',
    duration: number = 3000,
    position: 'top' | 'bottom' = 'top',
) {
    return {
        visible: true,
        message,
        type,
        duration,
        position,
    }
}

export async function wait(ms: number) {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
}

export function hashCode(str: string): string {
    let hash = 0, i, chr;
    if (str.length === 0) return hash.toString();
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convierte a entero de 32 bits
    }
    return hash.toString();
}